export const SERVER_URL = process.env.REACT_APP_SERVER as string;
export const CHAT_NAMESPACE = "/chat";
